import { useEffect } from 'react'
import { APP_VERSION } from '../version'

const CHECK_INTERVAL_MS = 5 * 60 * 1000
const RELOAD_FLAG_PREFIX = 'app-version-reload:'

const checkForNewVersion = async () => {
	try {
		const response = await fetch(`/version.json?ts=${Date.now()}`, { cache: 'no-store' })
		if (!response.ok) return

		const { version: latestVersion } = await response.json()
		if (!latestVersion || latestVersion === APP_VERSION) return

		const reloadFlag = `${RELOAD_FLAG_PREFIX}${latestVersion}`
		if (sessionStorage.getItem(reloadFlag)) return

		sessionStorage.setItem(reloadFlag, '1')
		window.location.reload()
	} catch {
		// Network/parse errors are ignored; the next scheduled check will retry.
	}
}

export const useAppVersionCheck = () => {
	useEffect(() => {
		checkForNewVersion()

		const intervalId = setInterval(checkForNewVersion, CHECK_INTERVAL_MS)

		const handleVisibilityChange = () => {
			if (document.visibilityState === 'visible') {
				checkForNewVersion()
			}
		}
		document.addEventListener('visibilitychange', handleVisibilityChange)

		return () => {
			clearInterval(intervalId)
			document.removeEventListener('visibilitychange', handleVisibilityChange)
		}
	}, [])
}
